import { Link16 } from '@carbon/icons-react';
import React from 'react';

export function ShortcutIcon() {
  // TODO: TooltipIcon is not working here.
  return <Link16 />;
}
